
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import EnhancedCheckbox from '../../SharedComponents/EnhancedCheckbox';

import { useAddCampaignContent, useAddPlaylistContent } from '../../../queries';
import { useScrollLoadingContext } from '../../Contexts/ScrollLoadingContext';
import { setLastElement } from '../../../redux/Slices/scrollSlice';
import ScrollContainer from '../../SharedComponents/ScrollContainer';
import SearchInput from '../../SharedComponents/AddContentPopup/SearchInput';

function MediaList({ path }) {
    const { t } = useTranslation();
    const { ids, setIds, } = useScrollLoadingContext();
    const { isFetching, data, params } = useSelector((state) => state.scroll);

    const screenDetails = useSelector((state) => state.layout.screenDetails);
    const { assign, layer } = useSelector((state) => state.global);

    const addCampaignContent = useAddCampaignContent()
    const addPlaylistContent = useAddPlaylistContent()
    const lastElementRef = useRef(null);
    const dispatch = useDispatch();
    const { id } = useParams();

    const onMediaChange = (e) => {
        let selectedMedia = [...ids];

        if (e.checked)
            selectedMedia.push(e.value);
        else
            selectedMedia.splice(selectedMedia.indexOf(e.value), 1);

        setIds(selectedMedia);
    }

    useEffect(() => {
        if (assign) {
            assignHandler()
        }
    }, [assign]);

    const assignHandler = async () => {
        if (window.location.pathname.includes("playlist"))
            await addPlaylistContent.mutateAsync({
                "list_media_ids": ids,
                "playlist_id": id,
                "layer": layer,
            })
        else {
            await addCampaignContent.mutateAsync({
                "ids_list": ids,
                "campaign_id": window.location.pathname.includes("layout") ? screenDetails.id : id,
                "layer": layer,
                "type": "media",
            })
        }
    };

    useEffect(() => {
        if (lastElementRef.current) {
            dispatch(setLastElement(lastElementRef.current));
        }
    }, [lastElementRef.current]);

    return (
        <>
            <SearchInput isDisabled={data?.length === 0} />

            <ScrollContainer path={path} >
                {
                    !isFetching && data?.length == 0 ?
                        <h5 className="py-5 text-center w-100"> {isEmpty(params?.search) ? t('multi3d.empty_no_files') : t('multi3d.empty_no_results')}</h5>
                        :
                        <div className="d-flex flex-column scroll_container scroll_div w-100">

                            <div className="d-flex flex-wrap mt-2 mb-4 ">
                                {data?.map((item, index) =>
                                (
                                    <div className={` ${ids.indexOf(`${item.id}`) !== -1 ? "bg-gray-200" : ""} px-2 w-100 d-flex align-items-center justify-content-between   py-2`} ref={index === data?.length - 1 ? lastElementRef : null}
                                        key={item?.id + index} >
                                        <label htmlFor={item?.id} className="col-11 d-flex ">
                                            <div className="col-2 mx-2 ">
                                                <div className={`p-4 d-flex bg-secondary align-items-center justify-content-center playlist_icon_container w-75`}>
                                                    <span className=" fs-6 text-white">3D</span>
                                                </div>
                                            </div>
                                            <div className="col-9 col-md-3 col-sm-6 mx-1 fs-6 d-flex align-items-center "> {item?.file_name} </div>
                                            <div className="col-4 d-flex align-items-center justify-content-center text-capitalize d-none d-sm-block text-light my-auto text-[12px] font-bold">
                                                {(item?.type)?.replace(/_/g, ' ')}
                                            </div>
                                        </label>
                                        <EnhancedCheckbox
                                          inputId={item?.id}
                                          name="media"
                                          className='media_checkbox me-3'
                                          value={item?.id}
                                          onChange={onMediaChange}
                                          checked={ids.indexOf(`${item?.id}`) !== -1}
                                        />
                                    </div>
                                )
                                )
                                }
                            </div>
                        </div>
                }
            </ScrollContainer >
        </>
    );
}

export default MediaList